@let state = maintenance.state();
<div
	class="fixed inset-0 z-[2000] flex items-center justify-center overflow-y-auto bg-white p-6 dark:bg-slate-900"
	role="alertdialog"
	aria-modal="true"
	aria-labelledby="maintenance-title">
	<div class="mx-auto flex w-full max-w-md flex-col items-center gap-y-6 text-center">
		<img
			src="assets/images/mitp.webp"
			class="w-16"
			alt="MedInThePocket" />
		<mat-icon class="!h-16 !w-16 !text-[64px] text-primary">engineering</mat-icon>
		<div class="flex flex-col gap-y-3">
			<h1
				id="maintenance-title"
				class="text-2xl font-semibold">
				{{ "maintenance.title" | translate }}
			</h1>
			<p class="whitespace-pre-line text-base text-slate-600 dark:text-slate-300">
				{{ state?.message || ("maintenance.default-message" | translate) }}
			</p>
			@if (state?.until) {
				<p class="text-sm font-semibold">
					{{ "maintenance.until" | translate: { time: (state?.until | date: "dd/MM/yyyy HH:mm") } }}
				</p>
			}
		</div>
		<p class="text-sm text-slate-500 dark:text-slate-400">{{ "maintenance.checking" | translate }}</p>
	</div>
</div>
